import { useI18n } from "../../contexts/I18nContext";
import { MinusOutlined, CloseOutlined } from "@ant-design/icons";
import { Flex, Popover, Modal } from "antd";
import { closeSession, getAgentList, switchLanguages } from "../../services";
import { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import { getAgentFromScript } from "../../utils";

//头部右侧内容
const RenderExtraContent = ({
  agentData,
  handleCloseCard,
  cardRef,
  setIsCloseSession,
  setAgentData,
  setDialogueMessages,
  closeSSE,
}: any) => {
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const { locale, setLocale, formatMessage } = useI18n();

  //获取智能体初始化列表
  const getAgentInitList = useCallback(async () => {
    try {
      const { data } = await getAgentList({
        agent: getAgentFromScript(),
      });
      setAgentData(data);
      setDialogueMessages(data?.messages);
    } catch (error) {
      console.error(error);
    }
  }, [setAgentData, setDialogueMessages]);

  //获取语言列表内容
  const getLangContent = useCallback(() => {
    const { setting } = agentData;

    return (
      <div className="language-content">
        {setting?.lang_list?.map((item: any) => {
          // const curLocale: any = getCurLocale(item.code);
          return (
            <div
              className={`language-text ${
                locale === item.code ? "actived" : ""
              }`}
              key={item.code}
              onClick={async () => {
                const res: any = await switchLanguages({
                  agent: getAgentFromScript(),
                  lang: item?.code,
                });
                if (res.code === 0) {
                  setLocale(item.code);
                  setPopoverOpen(false);
                  //重新初始化对话
                  getAgentInitList();
                }
              }}
            >
              {item.description}
            </div>
          );
        })}
      </div>
    );
  }, [agentData, locale, setLocale, getAgentInitList]);

  return (
    <>
      <Flex align="center" style={{ gap: 24 }}>
        <Popover
          content={getLangContent()}
          trigger="click"
          placement="bottom"
          open={popoverOpen}
          onOpenChange={(open: boolean) => {
            setPopoverOpen(open);
          }}
          getPopupContainer={() => cardRef?.current || document.body}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
          >
            <path
              fill="#9b9999"
              fillRule="evenodd"
              d="M4.931 2.554a6.3 6.3 0 0 0-2.377 2.377 23 23 0 0 1 1.983-.394q.153-.998.394-1.983m1.734-.661a21 21 0 0 0-.579 2.46 23 23 0 0 1 3.828 0 21 21 0 0 0-.579-2.46 6.3 6.3 0 0 0-2.67 0M4.353 6.086a21 21 0 0 0-2.46.579 6.3 6.3 0 0 0 0 2.67q1.217.363 2.46.579a23 23 0 0 1 0-3.828m1.525 4.036c-.14-1.411-.14-2.833 0-4.244 1.411-.14 2.833-.14 4.244 0 .14 1.411.14 2.833 0 4.244-1.411.14-2.833.14-4.244 0m-1.341 1.341a23 23 0 0 1-1.983-.394 6.3 6.3 0 0 0 2.377 2.377 23 23 0 0 1-.394-1.983m2.128 2.644a21 21 0 0 1-.579-2.46c1.274.107 2.554.107 3.828 0q-.216 1.243-.579 2.46a6.3 6.3 0 0 1-2.67 0m7.442-7.442a21 21 0 0 0-2.46-.579 23 23 0 0 1 0 3.828q1.243-.216 2.46-.579a6.3 6.3 0 0 0 0-2.67m-2.644 4.798a23 23 0 0 1-.394 1.983 6.3 6.3 0 0 0 2.377-2.377q-.985.241-1.983.394m-.394-8.909q.241.985.394 1.983a23 23 0 0 1 1.983.394 6.3 6.3 0 0 0-2.377-2.377M.25 8a7.75 7.75 0 1 1 15.5 0A7.75 7.75 0 0 1 .25 8"
              clipRule="evenodd"
            ></path>
          </svg>
        </Popover>
        <MinusOutlined onClick={() => handleCloseCard()} />
        <CloseOutlined
          onClick={() => {
            setOpen(true);
          }}
        />
      </Flex>
      {/* 关闭弹窗 */}
      <Modal
        open={open}
        width={"60%"}
        wrapClassName={"custom-modal-wrap"}
        getContainer={() => cardRef?.current || document.body}
        onOk={async () => {
          handleCloseCard();
          const res: any = await closeSession({ agent: getAgentFromScript() });
          if (res?.code === 0) {
            closeSSE();
            setIsCloseSession(true);
          }
        }}
        onCancel={() => setOpen(false)}
        okText={formatMessage("okText")}
        cancelText={formatMessage("cancelText")}
      >
        <FormattedMessage id="closeContentText" />
      </Modal>
    </>
  );
};

export default RenderExtraContent;
